import { connect } from 'react-redux';
import { seedFetch } from '../../../store.async/seed/seed.actions';
import { Session } from './session';

const mapStateToProps = (state) => {
	return {
		nonce: state.seed && state.seed.nonce,
		autobetPaused: state.gameAutobet?.pause,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetch: () => dispatch(seedFetch()),
	};
};

const SessionContainer = connect(mapStateToProps, mapDispatchToProps)(Session);

export { SessionContainer };
